// extracted by css-extract-rspack-plugin
export default {"overlay":"Sgrrsw1s","popupOuter":"FTlSNmDo","popupBox":"eTndB8_v","popupBoxAnimated":"NaUYm2w_","getOutAnimation":"v2k7o3A1"};